module.exports = __webpack_public_path__ + "img/placehold_vertical.ea3b0b50.png";